import styled from 'styled-components';
import {
  Preview as MaterialPreview,
  GetApp as MaterialGetApp
} from '../../../../styles/icons';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Preview = styled(MaterialPreview)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;

export const GetApp = styled(MaterialGetApp)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;
